import {
  HStack,
  IconButton,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdWarningAmber } from "react-icons/md";
import { RiQrScan2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  openStudentReportModel,
  openUserQRCodeModel,
  openSuspendReasonModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  deleteStudentRequest,
  getInactiveStudentsRequest,
} from "../../../modules/admin-modules/students/Actions";
import SuspendReasonModal from "./models/suspend-reason";

const InactiveStudentsTable = ({ setSelectedData, searchTerm, inactivePeriod }) => {
  const inactiveStudents = useSelector((state) => state.students.inactiveStudents);

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.students.isLoading);
  const count = useSelector((state) => state.students.count);
  const isSuspend = useSelector((state) => state.students.isSuspend);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const [suspendStudent, setSuspendStudent] = useState(null);

  useEffect(() => {
    const timeId = setTimeout(() => {
      let flag;
      if (inactivePeriod === "oneWeek") {
        flag = 1;
      } else {
        flag = undefined;
      }
      dispatch(getInactiveStudentsRequest(pageNumber + 1, searchTerm || "", flag));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, inactivePeriod]);

  useEffect(() => {
    setSelectedData({});
    setSelected({ id: "" });
  }, [pageNumber]);

  const formatPhoneForWhatsApp = (phone) => {
    if (!phone) return null;

    let cleaned = phone.toString().replace(/[\s\-\(\)\[\]]/g, "");

    if (cleaned.match(/^(012|011|010|015)/)) {
      cleaned = "2" + cleaned;
    } else {
      if (cleaned.startsWith("+")) {
        cleaned = cleaned.substring(1);
      } else if (cleaned.startsWith("00")) {
        cleaned = cleaned.substring(2);
      }
    }

    return cleaned;
  };

  const PhoneCell = ({ phone }) => (
    <HStack spacing={2} alignItems="center">
      <Text>{phone}</Text>
      {phone && (
        <IconButton
          as="a"
          href={`https://wa.me/${formatPhoneForWhatsApp(phone)}`}
          target="_blank"
          rel="noopener noreferrer"
          variant="ghost"
          size="sm"
          colorScheme="green"
          aria-label="WhatsApp"
          icon={<FaWhatsapp />}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </HStack>
  );

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };

  const Data = inactiveStudents?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: <PhoneCell phone={data?.phone} />,
      parent_phone: <PhoneCell phone={data?.parent_phone} />,
      code: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="QR Code"
          fontSize="20px"
          icon={<RiQrScan2Line />}
          onClick={() => dispatch(openUserQRCodeModel())}
        />
      ),
      delete: (
        <Tooltip
          label={data?.deleted_at == null ? "ايقاف" : "تفعيل"}
          hasArrow
          placement="top"
        >
          <IconButton
            variant="outline"
            border="0"
            color="gray.600"
            aria-label="ايقاف"
            fontSize="20px"
            icon={
              <MdWarningAmber
                color={data?.deleted_at == null ? "red" : "green"}
              />
            }
            onClick={() => {
              setSelected({ id: data?.id });
              if (data?.deleted_at != null) {
                dispatch(deleteStudentRequest(data?.id));
              } else {
                setSuspendStudent(data);
                dispatch(openSuspendReasonModel());
              }
            }}
            isLoading={selected.id == data?.id ? isSuspend : false}
          />
        </Tooltip>
      ),
    };
  });

  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "Asquera code",
      accessor: "user_name",
    },
    {
      Header: " المجموعة",
      accessor: "group_name",
    },
    {
      Header: " Qr Code",
      accessor: "code",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
    {
      Header: " رقم  ولي الامر",
      accessor: "parent_phone",
    },
    {
      Header: "ايقاف",
      accessor: "delete",
    },
  ];

  return (
    <>
      <CTable
        selectedData={viewData}
        Columns={columns}
        Data={Data}
        path={"openModel"}
        Actions
        Title={``}
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        setPage={setPage}
        setPerPage={setPerPage}
        currentpage={pageNumber}
        setPageNumber={setPageNumber}
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={size}
        totalPage={Math.ceil(count / 50)}
      />

      <SuspendReasonModal studentData={suspendStudent} />
    </>
  );
};

export default InactiveStudentsTable;
